// extracted by mini-css-extract-plugin
module.exports = {"panel":"AboutPromoBook_panel__2WebE","panelSep":"AboutPromoBook_panelSep__16J7h","about":"AboutPromoBook_about__2TOoD","aboutContent":"AboutPromoBook_aboutContent__2Ghw7"};